import * as angular from "angular";
import {IController} from "angular";

export class BringozRangeSliderComponent implements IController {
  from: any;
  to: any;
  min: any;
  max: any;
  ticks: any;
  noOutput: any;
  onChange: any;

  defaultTicks: number = 60000;
  width: any;
  fromOutputLeft: any;
  toOutputLeft: any;

  constructor() {
  }

  $onInit() {
    this.ticks = this.ticks ? this.ticks : this.defaultTicks;

  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange()) {
      if (!this.noOutput) {
        this.fromOutputLeft = this.getOutputPercentage(this.from);
      }
    }
    if (changes.to && !changes.to.isFirstChange()) {
      if (!this.noOutput) {
        this.toOutputLeft = this.getOutputPercentage(this.to);
      }
    }
    if (changes.min && !changes.min.isFirstChange()) {
      if (!this.noOutput) {
        this.fromOutputLeft = this.getOutputPercentage(this.from);
        this.toOutputLeft = this.getOutputPercentage(this.to);
      }
    }
    if (changes.max && !changes.max.isFirstChange()) {
      if (!this.noOutput) {
        this.fromOutputLeft = this.getOutputPercentage(this.from);
        this.toOutputLeft = this.getOutputPercentage(this.to);
      }
    }
  }

  onSliderInit() {
    if (!this.noOutput) {
      this.width = document.getElementById('input-from').clientWidth;

      this.fromOutputLeft = this.getOutputPercentage(this.from);
      this.toOutputLeft = this.getOutputPercentage(this.to);
    }
  };

  onFromChanged() {
    let shouldMoveOutput = true;
    if (this.from + this.ticks >= this.to) {
      this.from = this.to - this.ticks;
      shouldMoveOutput = false;
    }

    if (!this.noOutput && shouldMoveOutput) {
      this.fromOutputLeft = this.getOutputPercentage(this.from);
    }
    this.onChange({from: this.from, to: this.to});
  }

  onToChanged() {
    let shouldMoveOutput = true;
    if (this.to - this.ticks <= this.from) {
      this.to = this.from + this.ticks;
      shouldMoveOutput = false;
    }
    if (!this.noOutput && shouldMoveOutput) {
      this.toOutputLeft = this.getOutputPercentage(this.to);
    }
    this.onChange({from: this.from, to: this.to});
  }

  private getOutputPercentage(outputValue) {
    var percentage = (outputValue - this.min) * 100 / (this.max - this.min);
    var offset = percentage > 30 ? 12 : 10;
    return percentage - (percentage / offset) + '%';
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozRangeSlider', {
    bindings: {
      from: '<',
      to: '<',
      min: '<',
      max: '<',
      ticks: '<', // In Milliseconds
      noOutput: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-range-slider/bringoz-range-slider.html',
    controller: BringozRangeSliderComponent
  });
